import { createSlice } from "@reduxjs/toolkit";
import { helpCenterReducer } from "../extraReducers/helpCenterReducer";

// 定义初始化数据
const initialState = {
  questionList: {} as any,
  questionType: {} as any,
  gameListConfig: {} as any,
  gameNewListConfig: {} as any,
  createGameNewsConfig: {} as any,
  uploadGamePictureConfig: {} as any,
  deleteGameListConfig: {} as any,
  changeGameManegentNewsConfig: {} as any,
  createGameConfig: {} as any,
  deleteGameConfig: {} as any,
  changeGameConfig: {} as any,
  uploadGamesPictureConfig: {} as any,
  outOrInGameConfig: {} as any

};

const helpCenterSlice = createSlice({
  name: "helpCenter",
  initialState,
  reducers: {},
  extraReducers: helpCenterReducer,
});

export const { } = helpCenterSlice.actions;

// 默认导出,到处的文件需要在store入口文件引入
export default helpCenterSlice.reducer;
